import React from 'react';

export const Preview = ({ width = 16, height = 16, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00037 7.33804C7.63217 7.33804 7.3337 7.63651 7.3337 8.0047C7.3337 8.37289 7.63217 8.67137 8.00037 8.67137C8.36856 8.67137 8.66703 8.37289 8.66703 8.0047C8.66703 7.63651 8.36856 7.33804 8.00037 7.33804ZM6.00037 8.0047C6.00037 6.90013 6.8958 6.0047 8.00037 6.0047C9.10493 6.0047 10.0004 6.90013 10.0004 8.0047C10.0004 9.10927 9.10493 10.0047 8.00037 10.0047C6.8958 10.0047 6.00037 9.10927 6.00037 8.0047Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.933698 7.46638C1.22825 7.24547 1.64612 7.30516 1.86703 7.59971L2.85799 8.92099C3.48188 9.67718 4.26492 10.2865 5.15134 10.7055C6.0421 11.1266 7.01511 11.345 8.00037 11.345C8.98562 11.345 9.95863 11.1266 10.8494 10.7055C11.7358 10.2865 12.5189 9.67718 13.1428 8.92097L14.1337 7.59971C14.3546 7.30516 14.7725 7.24547 15.067 7.46638C15.3616 7.68729 15.4213 8.10516 15.2004 8.39971L14.2004 9.73305C14.1945 9.7409 14.1884 9.74862 14.1822 9.75621C13.4317 10.6698 12.4881 11.4057 11.4192 11.911C10.3503 12.4162 9.18267 12.6783 8.00037 12.6783C6.81806 12.6783 5.65044 12.4162 4.58154 11.911C3.51263 11.4057 2.569 10.6698 1.81855 9.75621C1.81232 9.74862 1.80625 9.7409 1.80036 9.73305L0.800365 8.39971C0.579451 8.10516 0.639146 7.68729 0.933698 7.46638Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00037 4.65072C7.01511 4.65072 6.0421 4.8691 5.15134 5.29015C4.26492 5.70916 3.48188 6.3185 2.85799 7.0747L1.86703 8.39598C1.64612 8.69053 1.22825 8.75022 0.933699 8.52931C0.639147 8.3084 0.579451 7.89053 0.800364 7.59598L1.80036 6.26264C1.80625 6.25479 1.81232 6.24707 1.81855 6.23948C2.569 5.32588 3.51263 4.58997 4.58154 4.08471C5.65044 3.57944 6.81806 3.31738 8.00037 3.31738C9.18267 3.31738 10.3503 3.57944 11.4192 4.08471C12.4881 4.58997 13.4317 5.32588 14.1822 6.23948C14.1884 6.24707 14.1945 6.25479 14.2004 6.26264L15.2004 7.59598C15.4213 7.89053 15.3616 8.3084 15.067 8.52931C14.7725 8.75022 14.3546 8.69053 14.1337 8.39598L13.1427 7.0747C12.5188 6.3185 11.7358 5.70916 10.8494 5.29015C9.95863 4.8691 8.98562 4.65072 8.00037 4.65072Z"
      fill="currentColor"
    />
  </svg>
);
